import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { DashboardBranchPerformanceResponseModel } from '@/types'

export const getDashboardBranchPerformance = async (
  branchName: string,
  startDate: string,
  endDate: string,
  chartType: string,
  dateType: string
): Promise<DashboardBranchPerformanceResponseModel> => {
  try {
    const response = await axios.get(
      `${BASE_URL}/dashboard/branch-performance`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          branch_names: branchName,
          chart_type: chartType,
          date_type: dateType,
        },
      }
    )

    return response.data
  } catch (error) {
    throw error
  }
}
